import * as React from 'react';
import { Alert, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { Dispatch } from 'redux';
import axios, { AxiosError } from 'axios';
import { HoursUntilStale } from '../../../types/Common/HoursUntilStale';
import { IPowerBiReportViewerObject } from '../../../types/Common/IPowerBiReportViewerObject';
import { PowerBiObjectType } from '../../../types/Common/PowerBiObjectType';


type EditStaleHoursModalProps = {
    dispatch: Dispatch;
    powerBiObject: IPowerBiReportViewerObject;
    //report: Report | undefined;
    //dashboard: Dashboard | undefined;
    updateHoursUntilStale: any;
    hideModal: any;
    showModal: boolean;
}

interface EditStaleHoursModalState {
    isLoaded: boolean;
    hoursUntilStale: number | undefined;
    validated: boolean;
    hasError: boolean;
    errorMessage: string;
}

class EditStaleHoursModal extends React.Component<EditStaleHoursModalProps, EditStaleHoursModalState> {
    public constructor(props: EditStaleHoursModalProps) {
        super(props);
        this.state = {
            isLoaded: false,
            hoursUntilStale: 0,
            validated: false,
            hasError: false,
            errorMessage: '',
        }
    }

    private setupEditState() {
        if (this.props.powerBiObject) {
        //if (this.props.report) {
            this.setState({
                hoursUntilStale: this.props.powerBiObject.hoursUntilStale,
                //hoursUntilStale: this.props.report.hoursUntilStale,
            });
        }
    }

    // Reset the modal state to default
    private resetState() {
        this.setState({
            hoursUntilStale: this.props.powerBiObject.hoursUntilStale,
            //hoursUntilStale: this.props.report ? this.props.report?.hoursUntilStale : this.props.dashboard?.hoursUntilStale,
            errorMessage: "",
            hasError: false,
        });
        this.setState({validated: false});
    }

    private handleCloseModal() {
            this.props.hideModal();
            this.resetState();
    }

    private handleSubmit(e: React.FormEvent<HTMLInputElement>){
        e.preventDefault();
        e.stopPropagation();

        //console.log(`Is the report prop populated? ${this.props.report}`);
        //console.log(`Is the report Id populated? ${this.props.report && this.props.report.id ? this.props.report.id : "false"}`);

        const form = e.currentTarget;

        let hoursUntilStaleDto = {} as HoursUntilStale;
        hoursUntilStaleDto.id = this.props.powerBiObject.id;
        //hoursUntilStaleDto.id = this.props.report ? this.props.report.id : this.props.dashboard.id;
        console.log("setting hoursUntilStaleDto.hoursUntilStale = this.state.hoursUntilStale ? this.state.hoursUntilStale : 0;");
        hoursUntilStaleDto.hoursUntilStale = this.state.hoursUntilStale ? this.state.hoursUntilStale : 0;

        console.log("calling requestUpdateHoursUntilStale");
        this.requestUpdateHoursUntilStale(hoursUntilStaleDto);
    }

    private requestUpdateHoursUntilStale(hoursUntilStaleDto: HoursUntilStale) {
        axios
        .patch<HoursUntilStale>(`./api/reports/${hoursUntilStaleDto.id}/hoursuntilstale`, hoursUntilStaleDto, { timeout: 30000 })
        .then((response: { data: HoursUntilStale; }) => {
            const { data } = response;
                this.props.updateHoursUntilStale();
                this.handleCloseModal();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;

            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }


    public render() {

        const updateHoursUntilStaleValue = (event: React.ChangeEvent<HTMLInputElement>) => {
           
            const value = parseInt(event.target.value);
            
            if (!Number.isNaN(value)) {
                this.setState({hoursUntilStale: value});
            }
            else if (!event.target.value) {
                this.setState({hoursUntilStale: undefined});
            }
        }


        return(
            <Modal size="lg" show={this.props.showModal} onShow={() => this.setupEditState()} onHide={() => this.handleCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        { this.props.powerBiObject.type == PowerBiObjectType.Dashboard ? "Edit Dashboard Stale Hours" : "Edit Report Stale Hours" }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                <Alert variant='danger' show={this.state.hasError ? true : false}>
                                    {this.state.errorMessage}
                                </Alert>
                            </Col>
                        </Row>
                        <Form
                            noValidate 
                            validated={this.state.validated} 
                            onSubmit={(e: React.FormEvent<any>) => this.handleSubmit(e)}
                        >
                            <Form.Group className="mb-3" as={Row} controlId="hoursUntilStale">
                                <Form.Label column md={2} className="fw-bold">
                                    Hours
                                </Form.Label>
                                <Col md={10}>
                                    <Form.Control 
                                    placeholder={"Total count of hours between dataset refreshes"}
                                    aria-label="Hours until stale"
                                    aria-describedby='hoursUntilStale'
                                    onChange={updateHoursUntilStaleValue}
                                    value={this.state.hoursUntilStale}
                                    />
                                </Col>
                            </Form.Group>
                            
                            <Form.Group as={Row} controlId="submit-btn">
                                <Col className="text-end">
                                    <Button variant="secondary" className="ms-3" type="submit">Update Hours Until Stale</Button>
                                    <Button variant="danger" className="ms-3" onClick={() => this.handleCloseModal()}>Cancel</Button>
                                </Col>
                            </Form.Group>

                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
    }
}

export default EditStaleHoursModal;